import React, { useEffect } from "react";

interface ModalProps {
    isOpen: boolean;
    title: string;
    onClose: () => void;
    children: React.ReactNode;
    width?: "md" | "lg" | "xl";
}

const Modal: React.FC<ModalProps> = ({
                                         isOpen,
                                         title,
                                         onClose,
                                         children,
                                         width = "lg",
                                     }) => {
    useEffect(() => {
        if (!isOpen) {
            return;
        }

        const handleKeyDown = (event: KeyboardEvent) => {
            if (event.key === "Escape") {
                onClose();
            }
        };

        document.body.style.overflow = "hidden";
        window.addEventListener("keydown", handleKeyDown);

        return () => {
            document.body.style.overflow = "";
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, [isOpen, onClose]);

    if (!isOpen) {
        return null;
    }

    return (
        <div className="modal-overlay" onClick={onClose}>
                <div
                    className={`modal-container modal-${width}`}
                    onClick={(event) => event.stopPropagation()}
                    role="dialog"
                    aria-modal="true"
                    aria-label={title}
                >
                    <div className="modal-header">
                        <div>
                            <h2 className="modal-title">{title}</h2>
                        </div>

                        <button
                            type="button"
                            className="modal-close-button"
                            onClick={onClose}
                            aria-label="Закрыть"
                        >
                            ×
                        </button>
                    </div>

                    <div className="modal-body">{children}</div>
                </div>
        </div>
    );
};

export default Modal;
